export const UPDATE_SAVING_RULES = 'UPDATE_SAVING_RULES';
export const UPDATE_SAVING_RULES_FAILURE = 'UPDATE_SAVING_RULES_FAILURE';
